<template>
  <v-layout align-center justify-center>
    <v-overlay v-if="loading" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-flex v-else xs12 sm8 md10>
      <v-layout align-center justify-center column>
        <v-img
          :src="require('@/assets/images/logo.png')"
          width="144px"
          height="144px"
        ></v-img>
        <div class="display-1 ma-3 font-weight-bold">Tradie Pass</div>
      </v-layout>
      <v-card class="pa-3">
        <v-card-title
          class="font-weight-bold justify-center text-center text-uppercase text-break"
        >
          Privacy Policy
        </v-card-title>
        <v-card-text>
          <div v-html="content" />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      content: null,
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      try {
        this.loading = true
        const { data } = await this.$api.get(`privacy`)
        this.content = data.data.content
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.display-1 {
  color: #fff;
}
.text-break {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
